import { render, staticRenderFns } from "./AddItemView.vue?vue&type=template&id=4ebf6b6b&scoped=true&"
import script from "./AddItemView.vue?vue&type=script&lang=ts&"
export * from "./AddItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf6b6b",
  null
  
)

export default component.exports